import React from 'react';
import clsx from 'clsx';

import Button from '@common/Button';
import Container from '@common/Container';
import Section from '@common/Section';
import SmallTitle from '@common/SmallTitle';
import Img from '@common/Image';
import Row from '@common/Row';
import RichText from '@common/RichText';

const ImageButtons = ({ data }) => {
  const {
    title,
    showTitle,
    text,
    imageMaxHeight,
    images,
    textColWidth,
    topMargin,
    bgColour,
    bgNoPadding,
    bgFullwidth
  } = data;
  return (
    <Section className={clsx(topMargin, {
        [`bg-${bgColour}`]: bgColour,
        'py-5': bgColour && !bgNoPadding,
        ['container']: !bgFullwidth
      })}>
      <Container>
        <Row className={`d-flex flex-column align-items-center justify-content-center`}>
          {(text || images) &&
            <div className={clsx('col text-center', textColWidth)}>
              {(showTitle && title) &&
                <SmallTitle>{title}</SmallTitle>
              }
              {text &&
                <RichText
                  json={text}
                  h1='mb-3'
                  h2='mb-3'
                  p='mb-3'
                  li='py-2'
                />
              }
              {images && images.map(image => (
                <Button key={image.id} addClass={'scale-1 shadow-none'} to={image.title}>
                  <Img
                    loading='eager'
                    image={image.gatsbyImageData}
                    file={image.file}
                    alt={image.description}
                    style={{ maxHeight: imageMaxHeight }}
                    imgStyle={{ objectFit: imageMaxHeight ? 'contain' : ''}}
                  />
                </Button>
              ))}
            </div>
          }
        </Row>
      </Container>
    </Section>
  )
}

export default ImageButtons
